import { useEffect, useState } from "react";
import { IoClose } from "react-icons/io5";
import { ActionIcon, Button, Modal, Text, Textarea } from "rizzui";
import { toast } from "sonner";
import useHandleErrors from "../../../../hooks/useHandleErrors";

interface AddCommentModalProps {
    service: (id: string, comment: string) => Promise<{ getResponseData: () => Promise<any> }>;
    id: string;
    isOpen: boolean;
    onClose: () => void;
    refetch: () => void;
}

export const AddCommentModal: React.FC<AddCommentModalProps> = ({ service, id, isOpen, onClose, refetch }) => {

    const { handleErrors } = useHandleErrors();

    const [comment, setComment] = useState<string>('');
    const [isSubmitting, setIsSubmitting] = useState<boolean>(false);

    useEffect(() => {
        if (!isOpen) {
            setComment('');
            setIsSubmitting(false);
        }
    }, [isOpen]);

    const addComment = async () => {
        const trimmedComment = comment.trim();

        if (!trimmedComment) {
            toast.error('El comentario no puede estar vacío');
            return;
        }

        if (!id) {
            toast.error('Debes seleccionar una incidencia antes de añadir el comentario');
            return;
        }

        setIsSubmitting(true);

        try {
            const response = await (await service(id, trimmedComment)).getResponseData();
            if (response.success) {
                toast.success('Se ha añadido un nuevo comentario');
                setComment('');
                refetch();
                onClose();
            } else {
                handleErrors(response);
            }
        } catch (error) {
            handleErrors(error);
        } finally {
            setIsSubmitting(false);
        }
    };

    return (
        <Modal
            isOpen={isOpen && Boolean(id)}
            onClose={onClose}
            size='sm'
            overlayClassName='backdrop-blur'
            containerClassName='!max-w-xl !shadow-xl'
            className='z-[999] [&_.pointer-events-none]:overflow-visible'
        >
            <div className='m-auto px-7 pt-6 pb-4'>
                <div className='mb-7 flex items-center justify-between'>
                    <Text className="text-xl">Añadir un comentario</Text>
                    <ActionIcon size='sm' variant='text' onClick={onClose}>
                        <IoClose className='h-auto w-6' strokeWidth={1.8} />
                    </ActionIcon>
                </div>

                <Textarea
                    id='comment'
                    label='Comentario'
                    rows={6}
                    value={comment}
                    onChange={(e) => setComment(e.target.value)}
                />
            </div>

            <div className='flex justify-center p-7'>
                <Button
                    disabled={!comment.trim() || isSubmitting}
                    onClick={addComment}
                    color='primary'
                >
                    Añadir comentario
                </Button>
            </div>
        </Modal>
    );
};
